import store from '@/store';
import CalculateFMCService from '@/services/DataProcess/CalculateFMCService'

import { getTranslationPop } from '@/services/Base/TranslationUtils';

const DataWatcherService = {
  init() {
    if (!store.state.kit.deepAncestryCoordinate) {
      return;
    }
    const resolveSource = CalculateFMCService.codeDataToArray(store.state.kit.deepAncestryCoordinate);
    if (resolveSource.isSuccess) {
      CalculateFMCService.onSetTarget(resolveSource.result);
    }

    this.runNotableIndividualResult();
  },

  async runNotableIndividualResult() {
    try {
      const sourceDataResult = await store.dispatch('ancientProxSourceData/fetchNotableIndividualSourceData');
      if (!sourceDataResult) {
        return;
      }
      
      const resolveSource = CalculateFMCService.codeDataToArray(sourceDataResult.sourceData);
      if (resolveSource.isSuccess) {
        CalculateFMCService.onSetSource(resolveSource.result);
      }

      CalculateFMCService.dataObject.maxDistOutPut = 50;
      const calculatedResult = await CalculateFMCService.calculateDistance(0);
     
      const groupedSourceCodes = calculatedResult.map(item => item.title);
      const uiDetailDataResult = await store.dispatch('ancientNotableIndividualResult/fetchDetails', groupedSourceCodes);
      if (!uiDetailDataResult) {
        return;
      }

      calculatedResult.forEach(resultItem => {
        resultItem.tTitle = getTranslationPop(store, resultItem.title, 'title', resultItem.title.replaceAll('*', ' '));

        const detailItem = uiDetailDataResult.find(x => x.sourceCode === resultItem.title);
        if (detailItem) {
          resultItem.id = detailItem.id;
          resultItem.logoUrl = detailItem.logoUrl;
          resultItem.sourceCode = detailItem.sourceCode;
        }
      });
      
      store.commit('ancientNotableIndividualResult/setUiResults', calculatedResult);
    } catch (error) {
      console.error('Error handling specific state change:', error);
    }
  },
};

export default DataWatcherService;
